import { lazy, Suspense } from 'react';
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
} from 'react-router-dom';
import { PasswordChangeGate } from '../components/auth/PasswordChangeGate';
import { ProtectedRoute } from '../components/auth/ProtectedRoute';
import { isAuthenticated } from '../utils/auth';
import { BackOfficeLayout } from './layouts/BackOfficeLayout';

const LoginPage = lazy(() => import('../pages/LoginPage'));
const ChangePasswordPage = lazy(() => import('../pages/ChangePasswordPage'));
const DashboardPage = lazy(() => import('../pages/DashboardPage'));
const ProcessListPage = lazy(() => import('../pages/ProcessListPage'));
const ProcessDetailPage = lazy(() => import('../pages/ProcessDetailPage'));

function PageLoader() {
  return (
    <div className="grid min-h-screen place-items-center text-text-secondary" role="status">
      A preparar página...
    </div>
  );
}

function IndexRedirect() {
  return <Navigate to={isAuthenticated() ? '/dashboard' : '/login'} replace />;
}

export function AppRouter() {
  return (
    <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<IndexRedirect />} />
          <Route path="/login" element={<LoginPage />} />
          <Route element={<ProtectedRoute />}>
            {/* Everything behind the login also passes the password gate, so a
                pending first-login change cannot be skipped by deep-linking. */}
            <Route element={<PasswordChangeGate />}>
              <Route path="/alterar-palavra-passe" element={<ChangePasswordPage />} />
              <Route element={<BackOfficeLayout />}>
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/processes" element={<ProcessListPage />} />
                <Route path="/processes/:processId" element={<ProcessDetailPage />} />
              </Route>
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
